const HeartIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="solar:health-outline">
      <path
        d="M17.25 7C17.25 6.801 17.171 6.61 17.03 6.47C16.89 6.329 16.699 6.25 16.5 6.25C16.301 6.25 16.11 6.329 15.97 6.47C15.829 6.61 15.75 6.801 15.75 7V8.25H14.5C14.301 8.25 14.11 8.329 13.97 8.47C13.829 8.61 13.75 8.801 13.75 9C13.75 9.199 13.829 9.39 13.97 9.53C14.11 9.671 14.301 9.75 14.5 9.75H15.75V11C15.75 11.199 15.829 11.39 15.97 11.53C16.11 11.671 16.301 11.75 16.5 11.75C16.699 11.75 16.89 11.671 17.03 11.53C17.171 11.39 17.25 11.199 17.25 11V9.75H18.5C18.699 9.75 18.89 9.671 19.03 9.53C19.171 9.39 19.25 9.199 19.25 9C19.25 8.801 19.171 8.61 19.03 8.47C18.89 8.329 18.699 8.25 18.5 8.25H17.25V7Z"
        fill="url(#paint0_linear)"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.75 9.318C22.75 5.992 21.268 3.51 18.96 2.607C16.825 1.77 14.262 2.396 12 4.513C9.738 2.396 7.175 1.77 5.04 2.607C2.732 3.51 1.25 5.992 1.25 9.317C1.25 11.436 2.38 13.52 3.787 15.314C5.209 17.127 6.997 18.75 8.489 19.961L8.623 20.071C9.823 21.046 10.691 21.751 12 21.751C13.31 21.751 14.176 21.046 15.377 20.071L15.511 19.961C17.003 18.751 18.791 17.127 20.213 15.314C21.62 13.52 22.75 11.436 22.75 9.318ZM12.548 6.087C14.66 3.828 16.849 3.391 18.414 4.003C19.982 4.617 21.25 6.413 21.25 9.318C21.25 10.929 20.37 12.682 19.032 14.388C17.708 16.078 16.016 17.62 14.566 18.797C13.173 19.927 12.723 20.25 12 20.25C11.277 20.25 10.827 19.927 9.434 18.796C7.984 17.62 6.292 16.077 4.968 14.389C3.629 12.682 2.75 10.929 2.75 9.318C2.75 6.413 4.018 4.618 5.586 4.003C7.151 3.391 9.34 3.828 11.452 6.087C11.522 6.162 11.607 6.222 11.701 6.263C11.796 6.303 11.897 6.325 12 6.325C12.103 6.325 12.204 6.303 12.299 6.263C12.393 6.222 12.478 6.162 12.548 6.087Z"
        fill="url(#paint1_linear)"
      />
    </g>

    <defs>
      <linearGradient
        id="paint0_linear"
        x1="16.5"
        y1="6.25"
        x2="16.5"
        y2="21.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="black" />
        <stop offset="1" stopColor="#666666" />
      </linearGradient>

      <linearGradient
        id="paint1_linear"
        x1="12"
        y1="2.248"
        x2="12"
        y2="21.751"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="black" />
        <stop offset="1" stopColor="#666666" />
      </linearGradient>
    </defs>
  </svg>
);

export default HeartIcon;
